export default "__VITE_ASSET__BogWKZr___"